import { Platform } from "./platform";

export class Product {
  id: number;
  code: string;
  name: string;
  platformId: number;
  platform: Platform;
}
